export const CTRL_C = '\u0003';
export const CTRL_C_EXIT_CODE = 130;

export const CTRL_E = '\u0005';
export const CTRL_U = '\u0015';

// writing Ctrl+E moves the cursor to the end, Ctrl+U clears everything before the cursor
export const CLEAR_PROMPT = CTRL_E + CTRL_U;
